import { defineStore } from 'pinia'

export interface ShoppingAssistantFabState {
  // Whether the FAB is allowed on screen. Any component can toggle this via
  // show()/hide() to force-hide or restore the button independently of the
  // route, experiment, country, or sidebar open state.
  isVisible: boolean
}

/**
 * Manual visibility toggle for the shopping-assistant FAB. Dedicated store
 * so unrelated scopes can show or hide the button without touching the
 * sidebar open/close state. Persists nothing.
 */
export const useShoppingAssistantFab = defineStore('shoppingAssistantFab', {
  state: (): ShoppingAssistantFabState => ({
    isVisible: true,
  }),
  actions: {
    show() {
      this.isVisible = true
    },
    hide() {
      this.isVisible = false
    },
  },
})
